// src/useVersionCheck.js
import { useEffect } from "react";

export default function useVersionCheck() {
  useEffect(() => {
    fetch("/version.json?_=" + Date.now()) // prevent browser caching
      .then(res => res.json())
      .then(meta => {
        const currentVersion = localStorage.getItem("app_version");
        if (currentVersion && currentVersion !== meta.version) {
          // New version detected → clear cache + reload
          caches.keys().then(names => {
            names.forEach(name => caches.delete(name));
          });
          localStorage.setItem("app_version", meta.version);
        } else {
          localStorage.setItem("app_version", meta.version);
        }
      })
      .catch(() => {
        console.warn("Version check failed");
      });
  }, []);
}
